import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { listSteps } from './TransferHelper';
import { useDispatch } from 'react-redux';
import { incrementStep } from '../../redux/modules/transferFunding/stepActions';
import { FundingLayout } from '../Shared/FundingPageLayout/FundingLayout';
import Stepper from '../Shared/Stepper/Stepper';
import FundingReviewSummary from '../Shared/FundingReviewSummary/FundingReviewSummary';
import Faq from '../Shared/Faq/Faq';
import { TransferConstant } from './TransferConstant';
import { callApi, getEndpoint } from '../../utils/api';
import { storeFundingTrackingData } from '../../redux/modules/fundingTrackingData/fundingTrackingDataActions';
import {
  putFundingAction,
  getUserFundingInfo,
  NotApplicable,
} from '../../redux/modules/fundingTrackingData/fundingTrackingData.module';
import { FullPageLoader } from '../Shared/FullPageLoader/FullPageLoader';
import { APP_FAILURE } from '../../settings/settings';
import './TransferFunding.scss';
import {
  getPersonalInformation,
  getUserMessages,
} from '../../redux/modules/user/PersonalInformation/PersonalInformation.module';
import { getProductTypes } from '../../redux/modules/productTypes/productType.module';
import { getUrlParams, getPathName } from '../../utils/link-helper';
import { formatUSPhoneNumber } from '../../utils/utils';

const TransferFunding = () => {
  const dispatch = useDispatch();
  const [filteredSteps, setFilteredSteps] = useState([]);
  const currentStep = useSelector((state) => state?.currentStep?.initialState);
  const fundingTrackingData = useSelector(
    (state) => state?.fundingTrackingData
  );
  const fundingTrackingTransferData = useSelector(
    (state) =>
      state?.fundingTrackingData?.payload?.onboardingDataStore
        ?.onboardingDatastoreTransfer
  );
  const components = {
    ReviewTransfer: '3',
    TransferNextSteps: '4',
  };
  const [applicationState, setApplicationState] = useState({
    hasFailed: false,
    isLoading: true,
    isLoaded: false,
  });

  /* eslint-disable */
  useEffect(() => {
    if (
      fundingTrackingData?.isStoreLoading !== undefined &&
      fundingTrackingData?.isStoreLoaded !== undefined &&
      fundingTrackingData?.hasStoreFailed !== undefined
    ) {
      setApplicationState({
        ...applicationState,
        hasFailed: fundingTrackingData?.hasStoreFailed,
        isLoaded: fundingTrackingData?.isStoreLoaded,
        isLoading: fundingTrackingData?.isStoreLoading,
      });
      if (
        fundingTrackingData?.payload?.onboardingFundingMission?.status ===
        'IN_PROGRESS'
      ) {
        dispatch(incrementStep(listSteps.length - 1));
      }
    }
  }, [
    fundingTrackingData?.isStoreLoading,
    fundingTrackingData?.isStoreLoaded,
    fundingTrackingData?.hasStoreFailed,
    fundingTrackingData?.payload,
  ]);

  /* eslint-disable */
  useEffect(() => {
    setFilteredSteps(listSteps.filter((component) => component.stepper));
    const onPageStart = async () => {
      const url = window.location.href;
      const searchParams = getUrlParams(url);
      dispatch(getPersonalInformation());
      dispatch(getUserMessages());
      dispatch(dispatch(getProductTypes()));
      //
      const isExistingAccPage = getPathName(url).includes('existing-account');
      if (isExistingAccPage) {
        dispatch(getUserFundingInfo());
      } else if (searchParams?.selectedAgreementID) {
        dispatch(
          getUserFundingInfo(
            searchParams?.selectedAgreementID,
            TransferConstant.labels.TRANSFER
          )
        );
      } else {
        const onPageFail = async () => {
          dispatch(NotApplicable());
        };
        onPageFail();
      }
    };
    onPageStart();
  }, []);

  const fundingTrackingStore = useSelector(
    (state) => state?.fundingTrackingData?.store
  );

  const generateGuide = () => {
    const payloadSalesforce = {
      custodian: {
        custodianName:
          fundingTrackingTransferData?.externalFinancialInstituteName,
        ...(fundingTrackingTransferData?.csdId !== '' && {
          custodianID: fundingTrackingTransferData?.csdId,
        }),
      },
      accountType: fundingTrackingStore?.userAccountFundingData?.agreementType,
      fromAccountType:
        fundingTrackingStore?.userAccountFundingData?.agreementType,
      customerName: {
        firstName: fundingTrackingStore?.userAccountFundingData?.agreementParties[0]?.fullName?.split(
          ' '
        )[0],
        lastName: fundingTrackingStore?.userAccountFundingData?.agreementParties[0]?.fullName?.split(
          ' '
        )[1],
        middleName: '',
        suffix: '',
      },
      customerContact: {
        mailingAddress: {
          street1:
            fundingTrackingStore?.userAccountFundingData?.address.street1,
          street2:
            fundingTrackingStore?.userAccountFundingData?.address.street2,
          street3: '',
          city: fundingTrackingStore?.userAccountFundingData?.address.city,
          state: fundingTrackingStore?.userAccountFundingData?.address.state,
          zip: fundingTrackingStore?.userAccountFundingData?.address.zip,
          zip4: '',
        },
      },
      brokerageAccountNumber:
        fundingTrackingTransferData?.transferToAccountNumber,
    };
    //
    callApi(
      getEndpoint('transferSalesforce'),
      { method: 'POST', 'accept-version': '2.0' },
      JSON.stringify(payloadSalesforce)
    )
      .then((response) => {
        if (fundingTrackingData?.payload) {
          fundingTrackingData.payload.onboardingDataStore.onboardingDatastoreTransfer = {
            ...fundingTrackingData.payload.onboardingDataStore
              .onboardingDatastoreTransfer,
            salesforceTrackingID: response?.body?.transferTrackingID,
          };
        }
        dispatch(putFundingAction(fundingTrackingData));
      })
      .catch(() => {
        dispatch(putFundingAction(fundingTrackingData));
      });
  };

  const storeInstitutionPhoneNumber = () => {
    const custodianId =
      fundingTrackingData?.payload?.onboardingDataStore
        ?.onboardingDatastoreTransfer?.csdId;
    callApi(`${getEndpoint('custodianInstitutions')}/${custodianId}`)
      .then((response) => {
        // saving user input into redux store
        dispatch(
          storeFundingTrackingData({
            ...fundingTrackingData.store,
            institutionPhone:
              response?.body?.toraPhone &&
              formatUSPhoneNumber(response?.body?.toraPhone),
          })
        );
      })
      .catch((e) => {
        console.log('failed', e);
        dispatch(NotApplicable());
      });
  };

  const handleClick = () => {
    switch (listSteps[currentStep]?.id) {
      case components.ReviewTransfer:
        dispatch(incrementStep());
        if (
          !fundingTrackingTransferData?.hasOwnProperty(
            'salesforceTrackingID'
          ) ||
          !fundingTrackingTransferData?.salesforceTrackingID
        ) {
          generateGuide();
        }
        // getting instituation phone number.
        storeInstitutionPhoneNumber();
        break;
      case components.TransferNextSteps:
        window.open(TransferConstant.transferFunding.link.trpevents, '_blank');
        break;
      default:
        return () => {};
    }
  };

  const message = '';
  const getError = () => {
    if (applicationState.hasFailed) {
      return {
        type: APP_FAILURE,
        hasError: true,
      };
    }
    return {
      type: '',
      hasError: false,
    };
  };

  return (
    <div className="transfer-funding-container">
      <FullPageLoader
        isVisible={applicationState.isLoading}
        hasError={getError().hasError}
        errorType={getError().type}
        messages={message}
      />
      {applicationState?.isLoaded &&
        !applicationState?.hasFailed &&
        !applicationState?.isLoading && (
          <FundingLayout
            listSteps={listSteps}
            leftSection={listSteps[currentStep]?.component}
            wizard={
              filteredSteps[currentStep]?.showWizard && (
                <Stepper listSteps={filteredSteps} />
              )
            }
            faqSection={
              listSteps[currentStep]?.faq && (
                <Faq endPoint="faqTransferFunding" />
              )
            }
            summary={
              listSteps[currentStep]?.card.isActive && (
                <FundingReviewSummary
                  btnLabel={listSteps[currentStep].card.btnLabel}
                  fundingMethodType={
                    listSteps[currentStep].card.fundingMethodType
                  }
                  title={listSteps[currentStep].card.title}
                  subTitle={listSteps[currentStep].card.subTitle}
                  content={listSteps[currentStep].card.content}
                  footerTitle={listSteps[currentStep].card?.footerTitle}
                  summaryDesc={listSteps[currentStep].card.summaryDesc}
                  handleClick={handleClick}
                />
              )
            }
          />
        )}
    </div>
  );
};

export default TransferFunding;
